module.exports = __webpack_public_path__ + "static/media/welcome-edit.08aa32ce.png";